import { render, staticRenderFns } from "./resultCollaborationLogin.vue?vue&type=template&id=309766b8&"
import script from "./resultCollaborationLogin.vue?vue&type=script&lang=js&"
export * from "./resultCollaborationLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports